export default __webpack_public_path__ + "static/media/Mont-Regular.1d26d89f.otf";